import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';
import {global} from "../../environments/global";
declare var wx:any;
/*
  Generated class for the WxProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WxProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello WxProvider Provider');
  }

  getSignature() {
    return this.http.hPost('/sharetask/get_signature', { url: window.location.href.split('#')[0] ,app_name:global.app_name_real})
  }

  shareTask(state){

    return this.http.hPost('/sharetask/share',{state:state,app_name:global.app_name_real});

  }


}



// WEBPACK FOOTER //
// ./src/providers/wx/wx.ts